<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-eye`]" width="1em" height="1em" v-bind="$attrs"><path d="M0.164093 7.4375C2.83679 0.135437 13.1641 0.135571 15.8369 7.4375C15.9688 7.79807 15.9689 8.19413 15.8369 8.55469C13.1643 15.8569 2.83686 15.8568 0.164093 8.55469C0.0321633 8.1941 0.0321363 7.79808 0.164093 7.4375ZM14.5889 7.89453C12.3422 1.75625 3.65994 1.75633 1.41312 7.89453C1.38918 7.95997 1.38918 8.03222 1.41312 8.09766C3.65993 14.2359 12.3422 14.2361 14.5889 8.09766C14.6128 8.03232 14.6127 7.95987 14.5889 7.89453ZM8.00101 5.36719C9.45252 5.36737 10.6299 6.54455 10.6299 7.99609C10.6299 9.44763 9.45251 10.6248 8.00101 10.625C6.54935 10.625 5.37214 9.44774 5.3721 7.99609C5.37213 6.54444 6.54934 5.36719 8.00101 5.36719ZM8.00101 6.70117C7.28572 6.70117 6.70611 7.28082 6.70609 7.99609C6.70613 8.71136 7.28573 9.29102 8.00101 9.29102C8.71613 9.29084 9.29589 8.71125 9.29593 7.99609C9.2959 7.28093 8.71614 6.70135 8.00101 6.70117Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineEye',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
